
// src/components/fornecedor/FornecedorModal.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalBox = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  width: 500px;
`;

const Title = styled.h2`
  margin-top: 0;
`;

const Input = styled.input`
  width: 100%;
  margin-bottom: 12px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const Button = styled.button`
  background: ${(props) => (props.cancel ? '#ccc' : '#6a0dad')};
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

const FornecedorModal = ({ onClose, onSave, initialData = {} }) => {
  const { register, handleSubmit, reset, setValue } = useForm();
  const [cnpjCpfValue, setCnpjCpfValue] = useState('');

  useEffect(() => {
    reset(initialData);
    setCnpjCpfValue(initialData?.CNPJ_CPF || '');
  }, [initialData, reset]);

  // Função para aplicar máscara de CNPJ ou CPF
  const applyCnpjCpfMask = (value) => {
    // Remove tudo que não é dígito
    const cleanValue = value.replace(/\D/g, '');

    if (cleanValue.length <= 11) {
      // Máscara CPF: 000.000.000-00
      return cleanValue
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2');
    } else {
      // Máscara CNPJ: 00.000.000/0000-00
      return cleanValue
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})/, '$1-$2');
    }
  };

  // Handler para mudança no campo CNPJ/CPF
  const handleCnpjCpfChange = (e) => {
    const maskedValue = applyCnpjCpfMask(e.target.value);
    setCnpjCpfValue(maskedValue);
    setValue('CNPJ_CPF', maskedValue);
  };

  const submit = (data) => {
    onSave(data);
  };

  return (
    <Overlay>
      <ModalBox>
        <Title>{initialData?.COD_FORNECEDOR ? 'Editar Fornecedor' : 'Novo Fornecedor'}</Title>
        <form onSubmit={handleSubmit(submit)}>
          <Input
            {...register('CNPJ_CPF')}
            placeholder="CNPJ/CPF"
            value={cnpjCpfValue}
            onChange={handleCnpjCpfChange}
            maxLength={18}
          />
          <Input {...register('EMAIL')} placeholder="Email" />
          <Input {...register('FONE')} placeholder="Telefone" />
          <Input {...register('NOME')} placeholder="Nome" />
          <Input {...register('RAZAO_SOCIAL')} placeholder="Razão Social" />
          <ButtonRow>
            <Button cancel type="button" onClick={onClose}>Cancelar</Button>
            <Button type="submit">Salvar</Button>
          </ButtonRow>
        </form>
      </ModalBox>
    </Overlay>
  );
};

export default FornecedorModal;